import React from "react";
import { Link } from "react-router-dom";
import * as Icon from "react-feather";
import MeasureDetails from "../components/MeasureDetails";
import axios from "../util/Api";
import { tokensKey } from "../util/Constants";
import "antd/dist/antd.css";
import { Modal, Spin } from "antd";
import "flatpickr/dist/themes/light.css";
import Flatpickr from "react-flatpickr";
import { French } from "flatpickr/dist/l10n/fr.js";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import getStorage from "../context/auth";

/* ---------------------------------------------------------------------- */
/* Helpers                                                                */
/* ---------------------------------------------------------------------- */
const uniqByKeepLast = (data, key) => [...new Map(data.map((x) => [key(x), x])).values()];

const flatten = (arr = []) =>
  arr.reduce(
    (flat, toFlatten) =>
      toFlatten == null ? flat : flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten),
    []
  );

/* ---------------------------------------------------------------------- */
/* Item card                                                              */
/* ---------------------------------------------------------------------- */
function MeasureItem({ measure, isSelected, onSelected, onClicked }) {
  const styles = {
    borderStyle: isSelected ? "solid" : "",
    borderWidth: isSelected ? "5px" : "1px",
    borderRadius: isSelected ? "10px" : "3px",
    borderColor: isSelected ? "#2f55d4" : "lightgrey",
  };
  const hasBon = measure.latestBonLink !== null;
  const isDraft = hasBon ? "En cours" : "Pas de bon";

  return (
    <div className="col-lg-6 col-md-6 col-12 mt-4 pt-2">
      <div className="card blog rounded shadow overflow-hidden" style={styles} onClick={onSelected}>
        <div className="position-relative">
          <img
            src={measure.photo || "images/measure/default_boat.png"}
            className="card-img-top"
            style={{ objectFit: "cover", width: 390, height: 200 }}
            alt="Measure"
          />
        </div>
        <div className="card-body content">
          <small>
            <a href="javascript:void(0)" className="text-primary h6">
              {measure.date || "N/A"}
            </a>
          </small>
          <h5 className="mt-2 title text-dark">{measure.boat || "Unknown"}</h5>
          <a href="javascript:void(0)" onClick={onClicked} className="text-primary">
            Afficher détails <Icon.ChevronRight className="fea icon-sm" />
          </a>
          <ul className="list-unstyled d-flex justify-content-between border-top mt-3 pt-3 mb-0">
            <li className="text-muted small d-flex align-items-center">
              <Icon.Anchor className="fea icon-sm mr-2" /> {measure.tonnage || "N/A"}
              {!hasBon && <Icon.AlertCircle className="fea icon-sm text-warning ml-2" title="Pas de bon" />}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

/* ---------------------------------------------------------------------- */
/* Main list component                                                    */
/* ---------------------------------------------------------------------- */
class MeasuresList extends React.Component {
  constructor(props) {
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);
    super(props);
    this.state = {
      searchContent: "",
      isModalOpen: false,
      selectedItems: [],
      firstDate: sevenDaysAgo,
      secondDate: today,
      isLoading: false,
      measures: [],
      downloadingBons: false,
      boatOption: "Tous",
      merchandiseOption: "Tous",
      originPortOption: "Tous",
      arrivalPortOption: "Tous",
      userAnnexOption: "Tous",
    };
  }

  componentDidMount() {
    this.getMeasures();
  }

  /* ------------------------- fetch measures -------------------------- */
  getMeasures = () => {
    const tokensData = getStorage().getItem(tokensKey);
    if (!tokensData) {
      console.error("No tokens found in storage");
      this.setState({ isLoading: false });
      return;
    }
    const { jwt, user } = JSON.parse(tokensData);
    const { firstDate, secondDate } = this.state;
    const adjustedSecondDate = new Date(secondDate);
    adjustedSecondDate.setHours(23, 59, 59, 999);

    this.setState({ isLoading: true });

    axios
      .get(
        `api/mesures/all-summary?id=${user.id}&firstDate=${firstDate.toISOString()}&secondDate=${adjustedSecondDate.toISOString()}`,
        { headers: { Authorization: `Bearer ${jwt}` } }
      )
      .then((result) => {
        if (result.status !== 200) {
          console.error("API returned non-200 status:", result.status);
          this.setState({ isLoading: false });
          return;
        }
        console.log("Resuuuuult", result.data)
        const cleaned = result.data.map((m) => ({
          ...m,
          originPort: m.originPort ?? null,
          arrivalPort: m.arrivalPort ?? null,
          marchandises: Array.isArray(m.marchandises) ? m.marchandises : [],
          latestBonLink: m.latestBonLink ?? null,
          user_annexes: Array.isArray(m.user_annexes) ? m.user_annexes : [],
          date: m.date || "",
          boat: m.boat || "Unknown",
          tonnage: m.tonnage || "N/A",
          user: m.user
        }));
        console.log("Fetched measures:", cleaned);
        this.setState({ measures: cleaned, isLoading: false });
      })
      .catch((error) => {
        console.error("Error fetching measures:", error);
        this.setState({ isLoading: false });
      });
  };

  /* ------------------------- search handler -------------------------- */
  search = (e) => {
    e.preventDefault();
    const searchItem = document.getElementById("search-item");
    this.setState({ searchContent: searchItem?.value || "" });
  };

  /* ------------------------- select & download ----------------------- */
  selectAll = () => this.setState({ selectedItems: this.state.measures.map((m) => m.id) });

  downloadAll = () => {
    const { selectedItems, measures } = this.state;
    const files = measures
      .filter((m) => selectedItems.includes(m.id))
      .map((m) => m.latestBonLink)
      .filter(Boolean);

    if (files.length === 0) {
      console.warn("No files to download");
      return;
    }

    const zip = new JSZip();
    let done = 0;
    this.setState({ downloadingBons: true });

    files.forEach((file) => {
      axios
        .get(file.url, { responseType: "blob" })
        .then((res) => {
          zip.file(file.name, res.data, { binary: true });
          if (++done === files.length) {
            zip.generateAsync({ type: "blob" }).then((content) => saveAs(content, "bons.zip"));
            this.setState({ downloadingBons: false });
          }
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
          this.setState({ downloadingBons: false });
        });
    });
  };

  /* ------------------------- filter change hooks --------------------- */
  handleUserAnnexChange = (e) => this.setState({ userAnnexOption: e.target.value });
  handleBoatChange = (e) => this.setState({ boatOption: e.target.value });
  handleMerchandiseChange = (e) => this.setState({ merchandiseOption: e.target.value });
  handleOriginPortChange = (e) => this.setState({ originPortOption: e.target.value });
  handleArrivalPortChange = (e) => this.setState({ arrivalPortOption: e.target.value });

  handleClose = () => {
    // Always refresh the list when the modal is closed
    this.getMeasures();
    this.setState({ isModalOpen: false, selectedElement: null });
  };

  /* ------------------------- date parsing helper -------------------- */
  parseDate = (dateStr) => {
    if (!dateStr) return null;
    const parts = dateStr.split("/");
    if (parts.length !== 3) return null;
    return new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10));
  };

  /* ------------------------------------------------------------------ */
  /* Render                                                             */
  /* ------------------------------------------------------------------ */
  render() {
    const {
      isLoading,
      measures,
      searchContent,
      isModalOpen,
      selectedElement,
      firstDate,
      secondDate,
      boatOption,
      merchandiseOption,
      originPortOption,
      arrivalPortOption,
      selectedItems,
      downloadingBons,
      userAnnexOption,
    } = this.state;

    /* Build dropdown sources */
    const boats = uniqByKeepLast(measures.map((e) => e.boat), (it) => it).sort();
    const userAnnexes = uniqByKeepLast(
      flatten(measures.map((m) => m.user_annexes.map((u) => u.name))),
      (it) => it
    ).sort();
    const merchandises = uniqByKeepLast(flatten(measures.map((m) => m.marchandises)), (it) => it).sort();
    const originPorts = uniqByKeepLast(flatten(measures.map((m) => m.originPort)), (it) => it).sort();
    const arrivalPorts = uniqByKeepLast(flatten(measures.map((m) => m.arrivalPort)), (it) => it).sort();

    /* Filter measures */
    const filteredMeasures = measures.filter((item) => {
      let passes = true;

      if (searchContent) {
        passes = passes && (item.boat?.toUpperCase().includes(searchContent.toUpperCase()) ?? true);
      }
      if (boatOption !== "Tous") {
        passes = passes && item.boat === boatOption;
      }
      if (originPortOption !== "Tous" && item.originPort) {
        passes = passes && item.originPort === originPortOption;
      }
      if (arrivalPortOption !== "Tous" && item.arrivalPort) {
        passes = passes && item.arrivalPort === arrivalPortOption;
      }
      if (merchandiseOption !== "Tous" && item.marchandises?.length) {
        passes = passes && item.marchandises.some((e) => e === merchandiseOption);
      }
      if (userAnnexOption !== "Tous" && item.user_annexes?.length) {
        passes = passes && item.user_annexes.some((u) => u.name === userAnnexOption);
      }
      if (firstDate && item.date) {
        const itemDate = this.parseDate(item.date);
        passes = passes && itemDate && itemDate >= new Date(firstDate);
      }
      if (secondDate && item.date) {
        const itemDate = this.parseDate(item.date);
        const endDate = new Date(secondDate);
        endDate.setHours(23, 59, 59, 999);
        passes = passes && itemDate && itemDate <= endDate;
      }
      return passes;
    });

    console.log("Filtered measures:", filteredMeasures);

    return (
      <div className="col-lg-12 col-12">
        <div className="rounded shadow p-4">
          <h5 className="mb-0">Bons de jaugeage:</h5>
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="row text-left">
                <div className="col-lg-4 col-md-6">
                  <div className="form-group">
                    <label>Date début:</label>
                    <Flatpickr
                      value={firstDate}
                      onChange={(firstDateArr) => this.setState({ firstDate: firstDateArr[0] }, this.getMeasures)}
                      options={{ locale: French, dateFormat: "d/m/Y" }}
                      render={({ defaultValue, ...props }, ref) => (
                        <input
                          {...props}
                          defaultValue={defaultValue}
                          ref={ref}
                          name="date"
                          type="text"
                          className="flatpickr flatpickr-input form-control"
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="form-group">
                    <label>Date fin:</label>
                    <Flatpickr
                      value={secondDate}
                      onChange={(secondDateArr) => this.setState({ secondDate: secondDateArr[0] }, this.getMeasures)}
                      options={{ locale: French, dateFormat: "d/m/Y" }}
                      render={({ defaultValue, ...props }, ref) => (
                        <input
                          {...props}
                          defaultValue={defaultValue}
                          ref={ref}
                          name="date"
                          type="text"
                          className="flatpickr flatpickr-input form-control"
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="form-group">
                    <label>Clients Annexes:</label>
                    <select
                      className="form-control custom-select"
                      value={userAnnexOption}
                      onChange={this.handleUserAnnexChange}
                    >
                      <option value="Tous">Tous</option>
                      {userAnnexes.map((annexName) => (
                        <option key={annexName} value={annexName}>
                          {annexName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="row align-items-center">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Bateau:</label>
                        <select
                          className="form-control custom-select"
                          value={boatOption}
                          onChange={this.handleBoatChange}
                        >
                          <option value="Tous">Tous</option>
                          {boats.map((e) => (
                            <option key={e} value={e}>
                              {e}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Port chargement:</label>
                        <select
                          className="form-control custom-select"
                          value={originPortOption}
                          onChange={this.handleOriginPortChange}
                        >
                          <option value="Tous">Tous</option>
                          {originPorts.map((e) => (
                            <option key={e} value={e}>
                              {e}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Port déchargement:</label>
                        <select
                          className="form-control custom-select"
                          value={arrivalPortOption}
                          onChange={this.handleArrivalPortChange}
                        >
                          <option value="Tous">Tous</option>
                          {arrivalPorts.map((e) => (
                            <option key={e} value={e}>
                              {e}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Marchandises:</label>
                        <select
                          className="form-control custom-select"
                          value={merchandiseOption}
                          onChange={this.handleMerchandiseChange}
                        >
                          <option value="Tous">Tous</option>
                          {merchandises.map((e) => (
                            <option key={e} value={e}>
                              {e}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="subcribe-form pb-2">
            <form className="m-0" style={{ maxWidth: "800px" }}>
              <div className="form-group mb-0">
                <input
                  type="text"
                  id="search-item"
                  name="name"
                  className="rounded-pill shadow"
                  placeholder="Chercher bateau..."
                />
                <button type="submit" className="btn btn-pills btn-primary" onClick={this.search}>
                  Chercher
                </button>
              </div>
            </form>
            <div className="row mt-3 text-right">
              <Link className="badge badge-primary mr-2" onClick={this.downloadAll}>
                Télécharger bons sélectionnés (
                {measures
                  .filter((e) => selectedItems.includes(e.id))
                  .map((e) => e.latestBonLink)
                  .filter((e) => e != null).length}
                )
              </Link>
              <Link className="badge badge-outline-primary" onClick={this.selectAll}>
                Sélectionner tout
              </Link>
            </div>
            {measures.length !== 0 && (
              <div className="row justify-content-center">
                <div className="col-lg-12">
                  <div className="row text-right">
                    <p style={{ fontSize: "12px" }}>
                      {downloadingBons
                        ? "En cours de téléchargement"
                        : "Seulement la sélection des mesures avec des bons disponibles sera téléchargée"}
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
          {isLoading ? (
            <div className="row justify-content-center">
              <Spin />
            </div>
          ) : measures.length === 0 ? (
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 col-12">
                <div className="card features px-md-3 border-0 text-center">
                  <div className="icons rounded h1 text-center text-primary px-3">
                    <i className="uil uil-file-alt" />
                  </div>
                  <div className="card-body p-0 content">
                    <h5 className="mt-4">
                      <a href="javascript:void(0)" className="title text-dark">
                        Pas de mesures disponibles
                      </a>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="row projects-wrapper">
              {filteredMeasures.length === 0 ? (
                measures.map((measure) => (
                  <MeasureItem
                    key={measure.id}
                    measure={measure}
                    isSelected={selectedItems.includes(measure.id)}
                    onClicked={() => this.setState({ isModalOpen: true, selectedElement: measure })}
                    onSelected={() => {
                      this.setState((prevState) => {
                        let items = [...prevState.selectedItems];
                        if (!items.includes(measure.id)) {
                          items.push(measure.id);
                        } else {
                          items = items.filter((id) => id !== measure.id);
                        }
                        return { selectedItems: items };
                      });
                    }}
                  />
                ))
              ) : (
                filteredMeasures.map((measure) => (
                  <MeasureItem
                    key={measure.id}
                    measure={measure}
                    isSelected={selectedItems.includes(measure.id)}
                    onClicked={() => this.setState({ isModalOpen: true, selectedElement: measure })}
                    onSelected={() => {
                      this.setState((prevState) => {
                        let items = [...prevState.selectedItems];
                        if (!items.includes(measure.id)) {
                          items.push(measure.id);
                        } else {
                          items = items.filter((id) => id !== measure.id);
                        }
                        return { selectedItems: items };
                      });
                    }}
                  />
                ))
              )}
            </div>
          )}

          <Modal
            visible={isModalOpen}
            onCancel={this.handleClose}
            cancelText="Annuler"
            width={1000}
            footer={[]}
          >
            {selectedElement && (
              <MeasureDetails
                updatedUser={this.props.updatedUser}
                selectedElement={selectedElement.id}
                onUpdated={() => {
                  this.getMeasures();
                  this.setState({ isModalOpen: false });
                }}
                onLiteUpdated={() => this.getMeasures()}
              />
            )}
          </Modal>
        </div>
      </div>
    );
  }
}

export default MeasuresList;
